import React, { useCallback, useLayoutEffect, useState } from 'react';
import qs from 'query-string';

import Promo from 'app/components/screens/page-promo/Promo';
import styles from './PromoPreview.module.css';

interface IHash {
  t?: string,
  c?: string,
  u?: string,
  i?: string,
}

const init = {
  t: 'Button',
  c: '',
  u: '',
  i: '',
};

const PromoPreview: React.FC = () => {
  const [text, setText] = useState(init.t);
  const [color, setColor] = useState(init.c);
  const [image, setImage] = useState(init.i);
  const [url, setUrl] = useState(init.u);

  const parseHash = (hash: string) => {
    const results: IHash = qs.parse(hash);
    setText(results.t || init.t);
    setColor(results.c || init.c);
    setImage(results.i || init.i);
    setUrl(results.u || init.u);
  };
  const handleHashChange = useCallback(() => parseHash(window.location.hash), []);

  useLayoutEffect(() => {
    window.addEventListener('hashchange', handleHashChange, false);
    handleHashChange();
    return () => {
      window.removeEventListener('hashchange', handleHashChange, false);
    };
  }, [handleHashChange]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.frame}>
        <Promo
          title=""
          color={color}
          url={url}
          text={text}
          image={image}
          hasButton
        />
      </div>
    </div>
  );
};

export default PromoPreview;
